<span class="label">
  <span class="session-label d-xl-block d-none">{{ 'asm.agentSessionTimer.label' | cxTranslate }}:</span>
  <span class="time">{{ timeLeft | formatTimer }}
    {{ 'asm.agentSessionTimer.minutes' | cxTranslate }}</span>
</span>
<button type="reset" class="reset" title="{{ 'asm.agentSessionTimer.reset' | cxTranslate }}"
  (click)="resetTimer()">{{'asm.agentSessionTimer.reset' | cxTranslate }}</button>